<template>
  <div>
    <div>
      <b-form  ref="form" :style="{height: trHeight}" class="repeater-form">

        <!-- Row Loop -->
        <b-row v-for="(item, index) in items" :id="item.id" :key="item.id" ref="row">
          <b-col md="12" class="mb-1">
            <b-row>
              <!-- Item Name -->
              <b-col md="7">
                <v-select  :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" 
                          :reduce="val => val.geofence_id"
                          label="name" :options="options" v-model="item.area"/>

              </b-col>
              <!-- Cost -->
              <b-col md="2" class="pl-1 pr-1">
                <b-form-input v-model="item.count" type="number" :placeholder="$t('count')"/>
              </b-col>

               <b-col md="2" class="pl-1 pr-1">
                <b-form-input v-model="item.duration" type="number" :placeholder="$t('durations')"/>
              </b-col>

              <!-- Remove Button -->
              <b-col md="1" style="display: flex; align-items: center" class="mb-50 pl-0 pr-0">
                <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                          variant="outline-danger" class="mt-0 mt-md-0 btn-sm" @click="removeItem(index)">
                  <feather-icon icon="XIcon" class="mr-25"/>
                </b-button>
              </b-col>
            </b-row>

            <slot name="error"></slot>
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="repeatAgain">
              <feather-icon icon="PlusIcon" class="mr-25"/>
              <span>{{ $t('Add New Area')}}</span>
            </b-button>
          </b-col>
        </b-row>

      </b-form>
    </div>

  </div>
</template>

<script>

import vSelect from 'vue-select'
import Repeater from '@/@core/mixins/ui/repeater'
import {
  BForm, BFormGroup, BFormInput, BRow, BCol, BButton,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import { nextTick, onMounted, onUnmounted, ref, toRefs, watch } from '@vue/composition-api'


export default {
  components: {
    vSelect,
    BForm, BRow, BCol, BButton,
    BFormGroup, BFormInput,
  },
  directives: { Ripple, },
  props: {
    options: {
      type: Array,
      required: true

    },

    items: {
      type: Array,
      required: true
    }
  },

  setup(props, {root, emit}) {

    const form = ref(null)
    const row = ref(null)
    const nextId = ref(2)


    const { trHeight, trAddHeight, trTrimHeight, trSetHeight } = Repeater()

    window.addEventListener('resize', initTrHeight)
    onMounted(() => initTrHeight())
    onUnmounted(() => window.removeEventListener('resize', initTrHeight))

    const initTrHeight = () => {
      trSetHeight(null)
      nextTick(() =>  trSetHeight(form.scrollHeight))
    }

    const removeItem = (index) => {
      props.items.splice(index, 1)
      trTrimHeight(row.value[0].offsetHeight)
    }

    const repeatAgain = () => {

      props.items.push({
        id: nextId.value++,
        area: null,
        count: null,
        duration:null,
      })

      nextTick(() => trAddHeight(row.value[0].offsetHeight))
    }


    return {
      form,
      row,
      trHeight,
      repeatAgain,
      removeItem
    }

  },
}
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: visible;
  transition: .35s height;
}
</style>
